import { render, staticRenderFns } from "./CustomUserSelect2.vue?vue&type=template&id=66607a0b&lang=html"
import script from "./CustomUserSelect2.vue?vue&type=script&lang=js"
export * from "./CustomUserSelect2.vue?vue&type=script&lang=js"
import style0 from "./CustomUserSelect2.vue?vue&type=style&index=0&id=66607a0b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports